export default {
  boardMetadata: {
    tooltips: {
      nextTask: 'The task will become available after the previous one is completed',
      commonProgress: 'Progress of the adaptation plan',
      noPlans: 'No plans',
      deleteCards: 'Delete all tasks with the «Done» status',
      roadmap: 'The task from the IDP by self-assessment',
      roadmap360: 'The task from the IDP by 360',
      meetingTask: 'The task from the 1-on-1 meeting',
      manual: 'Task added manually',
      notDeleteSectionTop: "The task is in the obvious growth areas. You can't delete it",
      notDeleteFixed: "The task is in the fixed development plan. You can't delete it",
      fixedRoadmap: 'The task is in the fixed development plan.',
      overdue: 'The deadline for completing the task has expired',
      reminder: 'The deadline for completing the task is coming to an end',
    },
    stepsCompleted: 'Completed tasks',
    stepsAvailable: 'Available after completing step {step}',
    statuses: {
      study: 'Not done',
      done: 'Done',
      overdue: 'Overdue',
      new: 'New',
      progress: 'In progress',
      completed: 'Completed',
      expired: 'Expired',
    },
    noPlans: {
      user: "You don't have any assigned plans",
      supervisor: 'The employee has no assigned plans',
      bot: "To make sure you don't miss the assigned plan, connect {link} the assistant bot",
    },
    successMessages: {
      completedTask: 'Task completed successfully',
      completedPlan: 'Plan completed successfully',
      deleteMaterial: 'The task has been removed from the development plan',
      deleteMeetingTask: 'The task has been removed from the meeting',
      createTask: 'The task successfully created',
      changeTask: 'The task successfully changed',
    },
    errorMessages: {
      completedTask: 'Failed to complete task',
      adaptations: 'Failed to get list of adaptations',
      changeStatus: 'Failed to change the task status',
      deleteMaterial: 'Failed to delete the task from the development plan',
      deleteMeetingTask: 'Failed to delete the task from the meeting',
      createTask: 'Failed to create task',
      changeTask: 'Failed to change the task',
      moveTask: 'Failed to change the status of the task',
    },
    buttons: {
      complete: 'Complete task',
      close: 'Close',
      addTask: 'Add a task',
      removeTask: 'Delete the task',
    },
    formLabels: {
      tags: 'Tags',
      importance: 'Importance',
      period: 'Period',
      name: 'Name of the task',
      roadmap: 'Development plan',
      skillId: 'Competence',
      deadline: 'Deadline',
      typeId: 'Type of material',
    },
    confirmDeleteCard: {
      title: 'Delete?',
      text: 'The task will be removed only from the board.',
      description: 'If you want to remove a task from the development plan, check the box below.',
      label: {
        roadmap: 'Delete from the development plan',
        roadmap360: 'Delete from the development plan',
        meetingTask: 'Delete from the meeting',
      },
      tasks: 'The tasks will be removed only from the board.',
    },
    placeholders: {
      self: {
        noRoadmaps:
          "You don't yet have development plan to add tasks to the board. Wait until a score is organized by the organizers and development plans are generated.",
        noTasks:
          "You don't have any tasks on the board, but you can click on the «Add a task» button to create them yourself and continue the development process.",
      },
      notSelf: {
        noRoadmaps:
          'This employee does not yet have development plans to add tasks to the board. Make an assessment and development plans will be generated.',
        noTasks:
          'There are no tasks on the board, but you can click on the «Add a task» button to create them.',
      },
    },
    tags: {
      roadmap: 'Self-assessment',
      roadmap360: 'Score 360',
      manualTask: 'Manual task',
      meetingTask: '1-on-1',
    },
    newTask: 'New task',
    defaultTypeName: 'Website/useful resource',
    noSelectedPlans: 'There are no selected plans',
    commonProgress: 'Common progress',
    step: 'step',
    noDeadline: 'none',
    adaptationPlan: 'Adaptation plan',
    planDeadline: 'Plan deadline',
    materials: 'Material to study',
  },
};
